export default __webpack_public_path__ + "static/media/poloniex-logo.014bc5a8.svg";